<template>
  <div class="physioOperationalAnalysis">
    <el-menu :default-active="tabActive.toString()" mode="horizontal" @select="tabSelect">
      <template v-for="(item, index) in tabList">
        <el-menu-item :index="index.toString()">{{ item.name }}</el-menu-item>
      </template>
    </el-menu>
    <div class="content">
      <component :is="tabList[tabActive].component"></component>
    </div>
  </div>
</template>

<script>
  import appointmentData from './components/appointmentData.vue'
  export default {
    name: 'physioOperationalAnalysis',
    components: {
      appointmentData
    },
    data() {
      return {
        tabActive: 0,
        tabList: [
          { id: 1, name: '预约数据', component: 'appointmentData' }
        ]
      }
    },
    methods: {
      tabSelect (index) {
        this.tabActive = index
      }
    }
  }
</script>

<style lang="less" scoped>
  .physioOperationalAnalysis{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #fff;
    overflow: hidden;
  }

  .content {
    flex-grow: 1;
    box-sizing: border-box;
    padding: 16px;
    width: 100%;
    min-height: 0px;
  }
</style>
